import cookie from 'js-cookie'
import ms from 'milliseconds'

const POP_AFTER = ms.seconds(10)
const EXPIRE_AFTER = 7 // days
const COOKIE_NAME = 'heimat-newsletter-popup'
const OPEN = 'is-open'
const ESC = 27

/*
  get cookie
  if no cookie or "old"
    timeout -> popup
      onsent -> close
    onclose -> set cookie

  https://gist.github.com/clnmcgrw/83fd9c95c45506874c14
*/

export default function () {
  let $element = document.querySelector('[data-popup]')

  if (!$element) return

  let hashish = $element.getAttribute('data-popup')
  let value = cookie.get(COOKIE_NAME)
  
  if (value == null || value !== hashish) {
    setTimeout(pop, POP_AFTER)
  }

  function pop () {
    // Open
    $element.classList.add(OPEN)

    // Bind "close" button
    $element.addEventListener('click', onClick)
  }

  function onClick (event) {
    if (event.target.matches('[data-popup-close]')) {
      close()
    }
    if (event.target.matches('button[type="submit"]')) {
      setTimeout(close, 2000)
    }
  }

  // Bind "esc" key
  window.addEventListener('keydown', (event) => {
    if (event.keyCode === ESC && $element.classList.contains(OPEN)) {
      close()
    }
  })

  function close () {
    $element.classList.remove(OPEN)
    $element.removeEventListener('click', onClick)
    cookie.set(COOKIE_NAME, hashish, { expires: EXPIRE_AFTER })
  }
}
